import {
    setIsFocused,
    setSubject,
    setLinkedEmailEntity,
    setExtractionId,
} from '../actions/quickAddActions';
import { initializeQuickAdd } from '../actions/publicActions';
import { orchestrator } from 'satcheljs';
import { SUGGESTED_TASK_ENTITY_SUBTYPE } from 'owa-todo-types';

export const initializeQuickAddOrchestrator = orchestrator(initializeQuickAdd, actionMessage => {
    const { subject, linkedEmailEwsId, extractionId } = actionMessage;

    setSubject(subject);
    setIsFocused(true);
    setExtractionId(extractionId);

    if (linkedEmailEwsId) {
        const linkedEmailEntity = {
            Id: linkedEmailEwsId,
            EntitySubtype: SUGGESTED_TASK_ENTITY_SUBTYPE,
            DisplayName: subject,
        };
        setLinkedEmailEntity(linkedEmailEntity);
    }
});
